import { ParamsService } from '../services'

export default (id) => {
  return new Promise(async (resolve, reject) => {
    await ParamsService.getC57FormHistory(id)
      .then(response => resolve(response.data))
      .then(err => reject({ error: false }))
  })
}
